import { render } from "./TemplatesTable.vue?vue&type=template&id=5e0ec576&ts=true"
import script from "./TemplatesTable.vue?vue&type=script&lang=ts"
export * from "./TemplatesTable.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src437919039/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__